import type { LatLngTuple } from './geo';

/**
 * Decodes a precision-5 encoded polyline into [lat, lng] pairs.
 *
 * Returns an empty list for anything that is not a complete encoding, so a
 * damaged value draws nothing instead of a line to the wrong place.
 */
export function decodePolyline(encoded: string): LatLngTuple[] {
  const positions: LatLngTuple[] = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  const readDelta = (): number | null => {
    let shift = 0;
    let result = 0;
    let byte: number;
    do {
      if (index >= encoded.length) return null;
      byte = encoded.charCodeAt(index) - 63;
      index += 1;
      if (byte < 0 || byte > 63) return null;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    return (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
  };

  while (index < encoded.length) {
    const deltaLat = readDelta();
    const deltaLng = deltaLat === null ? null : readDelta();
    if (deltaLat === null || deltaLng === null) return [];
    lat += deltaLat;
    lng += deltaLng;
    positions.push([lat / 1e5, lng / 1e5]);
  }

  return positions;
}
